import React from "react";
import useSelect from "../hooks/useSelect";
import ResultComponent from "./ResultComponent";
import { CloseIcon, Container, Question, Wrapper } from "./styled";
import 최재형이미지 from "../assets/최재형-독립운동가.webp";
import styled from "styled-components";

interface Props {
  setScreen: React.Dispatch<React.SetStateAction<string>>;
}

const Stage4 = ({ setScreen }: Props) => {
  const ANSWER = 1; // 최재형 - 독립운동가
  const { select, onClickItem } = useSelect(ANSWER);

  return (
    <Container>
      <Question>
        이 인물은 독립운동가일까요
        <br />
        친일파일까요?
      </Question>

      <AnswerContainer>
        <Image src={최재형이미지} alt="최재형" />

        <Wrapper onClick={() => onClickItem(1)} $correct={!!select}>
          <Text>⓵ 독립운동가</Text>
          {select === 1 && <CloseIcon />}
        </Wrapper>
        <Wrapper onClick={() => onClickItem(2)} $incorrect={select === 2}>
          <Text>⓶ 친일파</Text>
          {select === 2 && <CloseIcon />}
        </Wrapper>
      </AnswerContainer>

      {!!select && (
        <ResultComponent
          select={select}
          answer={ANSWER}
          nextStage={5}
          setScreen={setScreen}
          desc={
            <Desc>
              <strong>최재형</strong>
              <br />
              러시아의 시베리아 지역에서 활동한 대한민국의 독립유공자. 러시아식
              이름은 초이 표트르 세묘노비치(Цой Пётр Семёнович)이며, 이명은
              최재형(崔在衡), 최도헌(崔都憲), 별명으론 최 페티카(Петька), 최
              비지깨가 있다. [4] 1962년 대한민국 건국훈장 독립장을 추서받았다.
              망국 전후 연해주 독립운동은 최재형을 빼놓고서는 기록할 수 없다. 그
              정도로 러시아에서 활동한 독립운동가 중 대단한 영향력을 미쳤던
              주역이다. 그동안 사학계에서는 연구가 부족한 과거에 그리 조명받지
              못했으며, 1990년대 후반에 들어서야 비로소 주목받게 되었다.
            </Desc>
          }
        />
      )}
    </Container>
  );
};

export default Stage4;

const Image = styled.img`
  width: 280px;
`;

const AnswerContainer = styled.div`
  display: flex;
  align-items: center;
  justify-content: center;

  flex-direction: column;

  margin-top: 20px;
`;

const Text = styled.div`
  font-size: 30px;
`;

const Desc = styled.div`
  font-size: 20px;

  & strong {
    font-size: 30px;
  }
`;
